import { type JSONContent } from '@tiptap/core';

import { toWorkspaceAgentPillNodeAttrs } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/workspaceAgentMentionSources';
import { WORKSPACE_AGENT_PILL_NODE_NAME } from '~/components/v2/components/workspace/workspace-agent-panel/tiptap/workspaceAgentPill';
import {
  buildWorkspaceAgentGuidedVariantRenameInstruction,
  resolveWorkspaceAgentGuidedVariantPromptRenameSuffix,
  WORKSPACE_AGENT_GUIDED_VARIANT_DEFAULT_OUTPUT,
  type WorkspaceAgentGuidedVariantOutput,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentGuidedVariantOutput';
import {
  buildWorkspaceAgentGuidedVariantSaveInstructionNodes,
  type WorkspaceAgentGuidedVariantSaveDestination,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentGuidedVariantSaveLocation';
import {
  buildWorkspaceAgentWatermarkPrompt,
  WORKSPACE_AGENT_WATERMARK_DEFAULT_RENAME_SUFFIX,
  type WorkspaceAgentWatermarkImage,
  type WorkspaceAgentWatermarkSettings,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentWatermark';

type BuildWorkspaceAgentWatermarkComposerContentParams = {
  destination: WorkspaceAgentGuidedVariantSaveDestination;
  image: WorkspaceAgentWatermarkImage;
  imageCount: number;
  output?: WorkspaceAgentGuidedVariantOutput;
  settings: WorkspaceAgentWatermarkSettings;
  skippedFileCount: number;
  skippedVideoCount: number;
};

/** Prompt paragraph with the chosen image already a pill node, ready to insert and send. */
export const buildWorkspaceAgentWatermarkComposerContent = ({
  destination,
  image,
  imageCount,
  output = WORKSPACE_AGENT_GUIDED_VARIANT_DEFAULT_OUTPUT,
  settings,
  skippedFileCount,
  skippedVideoCount,
}: BuildWorkspaceAgentWatermarkComposerContentParams): JSONContent[] => {
  const { afterImage, beforeImage } = buildWorkspaceAgentWatermarkPrompt({
    imageCount,
    output,
    settings,
    skippedFileCount,
    skippedVideoCount,
  });

  return [
    {
      content: [
        { text: beforeImage, type: 'text' },
        { attrs: toWorkspaceAgentPillNodeAttrs(image), type: WORKSPACE_AGENT_PILL_NODE_NAME },
        { text: afterImage, type: 'text' },
        ...buildWorkspaceAgentGuidedVariantSaveInstructionNodes(destination),
        {
          text: ` ${buildWorkspaceAgentGuidedVariantRenameInstruction(resolveWorkspaceAgentGuidedVariantPromptRenameSuffix(WORKSPACE_AGENT_WATERMARK_DEFAULT_RENAME_SUFFIX, output))}`,
          type: 'text',
        },
      ],
      type: 'paragraph',
    },
  ];
};
